import { useLocalStorage } from "primereact/hooks";
import { useState } from "react";

import { Option } from "../models/MultiAutocomplete.types";
import helpers from "../helpers/helpers";

type Props = {
  dataKey: string;
  length?: number;
  storageKey?: string;
};

export const useHistory = <T extends Option>({
  length = 10,
  dataKey,
  storageKey = "",
}: Props): [T[], (value: T) => void] => {
  const [history, setHistory] = useLocalStorage<T[]>([], storageKey);
  const [current, setCurrent] = useState<T[]>([]);

  const isHistory = !!storageKey && storageKey.length > 0;

  const addHistory = (value: T) => {
    const items = isHistory ? history : current;
    const setItems = isHistory ? setHistory : setCurrent;

    const newItems = helpers.removeDuplicates([value, ...items], dataKey);
    const newItemsSlice = newItems.length > length ? newItems.slice(0, length) : newItems;
    setItems(newItemsSlice);
  };

  return [isHistory ? history : current, addHistory];
};
